module.exports = {
      id: "hamburger-telegram-usage",
      viewBox: "0 0 36 37",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#hamburger-telegram",
      toString: function () {
        return this.url;
      }
    }